"use client"

import { BarebonesProductCard } from "./BarebonesProductCard"
import { BarebonesReveal } from "./BarebonesReveal"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { HttpTypes } from "@medusajs/types"

export const BarebonesProductRow = ({
  heading,
  cta,
  href,
  products,
  locale,
}: {
  heading: string
  cta?: string
  href?: string
  products: HttpTypes.StoreProduct[]
  locale: string
}) => {
  if (!products.length) return null

  return (
    <section className="mx-auto w-full max-w-[1440px] px-8 py-12">
      <BarebonesReveal className="mb-8 flex items-end justify-between gap-4">
        <h2 className="bb-serif text-4xl text-[#2b2118]">{heading}</h2>
        {cta && href && (
          <LocalizedClientLink
            href={href}
            className="group/cta relative text-[13px] uppercase tracking-[0.14em] text-[#5c5148] transition-colors hover:text-[#2b2118]"
          >
            {cta}
            <span className="absolute inset-x-0 -bottom-1 h-px origin-left scale-x-0 bg-[#2b2118] transition-transform duration-500 group-hover/cta:scale-x-100" />
          </LocalizedClientLink>
        )}
      </BarebonesReveal>
      <div className="grid grid-cols-2 gap-8 lg:grid-cols-4">
        {products.map((product, i) => (
          <BarebonesReveal key={product.id} delay={80 + i * 70} from="up">
            <BarebonesProductCard product={product} locale={locale} />
          </BarebonesReveal>
        ))}
      </div>
    </section>
  )
}
